// extracted by mini-css-extract-plugin
export default {"toggle":"collapse_toggle__ENTQl","icon":"collapse_icon__S8SMp"};